<div class="title-container">
  <svg-icon class="icon" src="/assets/icons/mountain.svg"></svg-icon>
  <h1 class="title">Challenges</h1>
</div>

<ng-container *ngIf="socialChallengeBloc.challengesStatus$ | async as challengesStatus">
  <ng-container *ngIf="socialChallengeBloc.challenges$ | async as challenges">
    <div class="challenge-categories">
      <ng-container *ngIf="challengesStatus.status === status.done && challenges?.length > 0; else loadingChallenges">
        <ng-container *ngIf="socialChallengeBloc.getChallengesByState$(challengeState.active) | async as active">
          <ng-container *ngIf="active?.length > 0">
            <h2 class="challenge-category-title">In Progress</h2>
            <div class="challenge-category-container">
              <kf-sc-social-challenge
                *ngFor="let challenge of active; trackBy: trackByChallengeId"
                [challenge]="challenge"></kf-sc-social-challenge>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="socialChallengeBloc.getChallengesByState$(challengeState.upcoming) | async as upcoming">
          <ng-container *ngIf="upcoming?.length > 0">
            <h2 class="challenge-category-title">Upcoming</h2>
            <div class="challenge-category-container">
              <kf-sc-social-challenge
                *ngFor="let challenge of upcoming; trackBy: trackByChallengeId"
                [challenge]="challenge"></kf-sc-social-challenge>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="socialChallengeBloc.getChallengesByState$(challengeState.ended) | async as ended">
          <ng-container *ngIf="ended?.length > 0">
            <h2 class="challenge-category-title">Ended</h2>
            <div class="challenge-category-container">
              <kf-sc-social-challenge
                *ngFor="let challenge of ended; trackBy: trackByChallengeId"
                [challenge]="challenge"></kf-sc-social-challenge>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #loadingChallenges>
      <ng-container
        *ngIf="
          challengesStatus.status === status.starting || challengesStatus.status === status.local;
          else noChallenges
        ">
        <h3 class="loading-challenge">Loading Challenges...</h3>
        <div class="loading-challenge-shimmers">
          <kp-shimmer class="challenge-shimmer"></kp-shimmer>
          <kp-shimmer class="challenge-shimmer"></kp-shimmer>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #noChallenges>
  <p class="empty-challenge">No Challenges currently available.</p>
</ng-template>
